import React from "react";
import { Helmet } from "react-helmet-async"; // Import Helmet for SEO
import "../App.css";
import "../index.css";
import Main from "../Components/Main";
import About_text from "../Components/About_text";
import Portfolio from "../Components/Portfolio";
import Clientwith from "../Components/Clientwith";
import OurServices from "../Components/OurServices";
import Vision from "../Components/Vision";
import Technologies from "../Components/Technologies";
import Blog from "../Components/Blog";
import Footer from "../Components/Footer";
import PopupOverlay from "../Components/PopupOverlay"; // Import the popup component

export default function Main_root() {
  return (
    <>
      {/* Add Helmet for SEO */}
      <Helmet>
        <title>Xebrand | Digital Marketing & Web Development Agency</title>
        <meta
          name="description"
          content="Xebrand is your partner for social media marketing, eCommerce solutions, full-stack web development, and personal branding. Grow your online business with us!"
        />
      </Helmet>
      
      {/* Add the popup overlay */}
      <PopupOverlay />
      <Main />
      <About_text />
      {/* <Portfolio /> */}
      <Clientwith />
      <OurServices />
      <Vision />
      <Technologies />
      {/* <Blog /> */}
      <Footer />
    </>
  );
}
